import React from 'react';
import { useDispatch } from 'react-redux'
import { Card, Tooltip, OverlayTrigger } from "react-bootstrap";
import { FaCartPlus } from "react-icons/fa";
import { bucket_url } from '../../constants/const'
import { addToCart } from '../../actions/cartActions'

import './publicationCard.module.css';
import { LinkContainer } from 'react-router-bootstrap';

const PublicationCard = ({ item, hide = false, disable = false }, ...props) => {

    const dispatch = useDispatch()

    const { _id, images, title, price, discount, image, cover } = item

    const handleCart = () => {
        item.quantity = 1
        dispatch(addToCart(item))
    }

    return (
        <>
            <div className="d-flex flex-column justify-content-center" styleName="publication-card-wrap">
                <Card className="flex-grow-1 p-2 p-md-3 p-lg-3" styleName="publication-card">
                    {
                        disable ?
                        <Card.Img className="img-fluid mb-3" styleName="publication-cover" variant="top" src={`${bucket_url}${!!cover ? cover : image}`} />
                        : <LinkContainer to={`/publication/${item.title.replace(/ /g, "-")}/${_id}`}>
                            <Card.Img className="img-fluid mb-3" styleName="publication-cover" variant="top" src={`${bucket_url}${!!cover ? cover : images[0]}`} />
                        </LinkContainer>
                    }
                    <Card.Body className="p-1 text-center">
                        <OverlayTrigger
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip>
                                    {title}
                                </Tooltip>
                            }
                        >
                            <Card.Title className={`${hide && 'mb-0'}`} styleName="publication-title">
                                {
                                    disable ?
                                    <Card.Link>{title}</Card.Link>
                                    : <LinkContainer to={`/publication/${item.title.replace(/ /g, "-")}/${_id}`}>
                                        <Card.Link>{title}</Card.Link>
                                    </LinkContainer>
                                }
                            </Card.Title>
                        </OverlayTrigger>
                    </Card.Body>
                </Card >
                {
                    !hide &&
                    <>

                    <div className="price-add-cart d-flex flex-column w-100">
                        <div className="d-inline-block text-center w-100 mt-3">
                            <Card.Link styleName="add-to-cart" className="d-inline-block mb-2" onClick={handleCart} style={{ cursor: 'pointer' }}><FaCartPlus className="react-icons mr-2 d-none d-md-inline" /> Add to cart</Card.Link>
                        </div>
                        {/* <span className="d-inline-block px-1 mb-1 ml-2" styleName="publication-price"> মূল্যঃ {price - discount}</span> */}
                        {(!!discount &&
                            <div className="d-inline-flex justify-content-center text-center flex-wrap align-items-end">
                                <span className="font-weight-bold px-1">মূল্যঃ</span>
                                <div className="d-flex flex-column">
                                    <span className="px-1">
                                        <span className="pr-1" styleName="has-discount">
                                            {price}
                                        </span>
                                        {price - discount} টাকা
                                    </span>
                                </div>
                            </div>
                        ) ||
                            (
                                (price === 0) ?
                                    <span className="d-inline-block text-center px-1 w-100">
                                        Free
                                    </span> :
                                    <span className="d-inline-block text-center px-1 w-100">
                                        <span className='font-weight-bold'>মূল্যঃ</span> {price - discount} টাকা
                                    </span>
                            )}
                    </div>
                    </>
                }
            </div>
        </>
    )
}

export default PublicationCard;